import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ESaveSearchActionType {
  ModalOpened = 'SAVE_SEARCH/MODAL/OPENED',
  ModalClosed = 'SAVE_SEARCH/MODAL/CLOSED',
}

export type TSaveSearchModalOpenedAction = ITypedReduxAction<ESaveSearchActionType.ModalOpened>;
export type TSaveSearchModalClosedAction = ITypedReduxAction<ESaveSearchActionType.ModalClosed>;

export type TSaveSearchActions = TSaveSearchModalOpenedAction | TSaveSearchModalClosedAction;
